import { NgModule } from '@angular/core';
import { RouterModule, Routes as AngularRoutes } from '@angular/router';

import { MultiQuestionComponent } from './pages/multi-question/multi-question.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SingleQuestionComponent } from './pages/single-question/single-question.component';
import { PredictedQuestionsComponent } from './pages/predicted-questions/predicted-questions.component';
import { AskPredefinedQuestionComponent } from './pages/ask-predefined-question/ask-predefined-question.component';
import { GeneratedKeywordsComponent } from './pages/generated-keywords/generated-keywords.component';
import { ConfigComponent } from './pages/config/config.component';
import { ArticleComponent } from './pages/article/article.component';
import { ArticlesComponent } from './pages/articles/articles.component';
import { TermsComponent } from './pages/terms/terms.component';
import { QuestionsComponent } from './pages/questions/questions.component';
import { QuestionComponent } from './pages/question/question.component';
import { DocumentsComponent } from './pages/documents/documents.component';

import { Routes } from './app-routing.models';
import { AuthGuard } from './shared/guards/auth/auth.guard';
import { AdminAuthGuard } from './shared/guards/admin-auth/admin-auth.guard';

const routes: AngularRoutes = [
  {
    path: Routes.SingleQuestion,
    component: SingleQuestionComponent,
    canActivate: [AuthGuard, AdminAuthGuard],
  },
  {
    path: Routes.Home,
    component: MultiQuestionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: Routes.PredictedQuestions,
    component: PredictedQuestionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: Routes.GeneratedKeywords,
    component: GeneratedKeywordsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: Routes.AskPredefinedQuestion,
    component: AskPredefinedQuestionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: Routes.Articles,
    component: ArticlesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: `${Routes.Articles}/:id`,
    component: ArticleComponent,
    canActivate: [AuthGuard],
  },
  {
    path: Routes.AdminConfig,
    component: ConfigComponent,
    canActivate: [AuthGuard, AdminAuthGuard],
  },
  {
    path: Routes.Terms,
    component: TermsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: Routes.Questions,
    component: QuestionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: `${Routes.Questions}/:id`,
    component: QuestionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: Routes.Documents,
    component: DocumentsComponent,
    canActivate: [AuthGuard, AdminAuthGuard],
  },
  
  { path: Routes.SignIn, component: SignInComponent },
  { path: Routes.Any, redirectTo: Routes.SignIn },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
